import { render, staticRenderFns } from "./PosInvoicesTaxRefund.vue?vue&type=template&id=6198dec9&scoped=true&"
import script from "./PosInvoicesTaxRefund.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198dec9",
  null
  
)

export default component.exports